interface ContextLoadingStateProps {
    message?: string;
}

export function ContextLoadingState({ message = 'Loading context...' }: ContextLoadingStateProps) {
    return (
        <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-900 to-gray-800">
            <div className="text-center space-y-4">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white/60 mx-auto" />
                <p className="text-white/80 text-lg">{message}</p>
            </div>
        </div>
    );
}

